import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '../ui/card';
import { Button } from '../ui/button';
import { ShieldAlert } from 'lucide-react';

interface AccessDeniedProps {
  featureName?: string;
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({ featureName }) => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-destructive/10 p-3">
              <ShieldAlert className="h-8 w-8 text-destructive" />
            </div>
          </div>
          <CardTitle className="text-2xl">Access Denied</CardTitle>
          <CardDescription>
            {featureName
              ? `The "${featureName}" feature is not enabled for your account.`
              : 'This feature is not enabled for your account.'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground text-center">
            If you believe you should have access to this feature, please contact your
            administrator or reach out to our support team.
          </p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button onClick={handleGoToDashboard} variant="default">
            Go to Dashboard
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};
